import { render } from "./topHead.vue?vue&type=template&id=1d7072a2&scoped=true"
import script from "./topHead.vue?vue&type=script&lang=js"
export * from "./topHead.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1d7072a2"

export default script